/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 24/02/22
 */

/**
 * Convert number to string with maximum number of decimal places
 * Trailing 0's are removed
 * @param num Number to convert
 * @param n Number of decimal places
 */
export const toTruncatedFixed = (num: number, n: number) => {
    const fixed = num.toFixed(n);
    return fixed.replace(/(.*?)0*$/, '$1').replace(/(.*?)\.$/, '$1');
};
